module.exports = __webpack_public_path__ + "img/kasprowicz.fc87edba.png";